import React, { useState, useEffect } from 'react';
import moment from 'moment';
import { Button } from 'primereact/button';
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { useRouteMatch, useHistory } from "react-router-dom";
import { BreadcrumbsItem } from 'react-breadcrumbs-dynamic';
import { InputText } from 'primereact/inputtext';
import { Fieldset } from 'primereact/fieldset';
import classNames from 'classnames';
import { moneyFormat, getTablePageReport } from "../../core/service/CommonService";
import { getPageOrders } from './OrderService';

import { APP_FEP, PAYMENT_STATE, ORDER_STATE } from '../../constants';
import { TableHeader } from '../../core/components/datatable-tools/TableHeader';
import { MultiSelect } from 'primereact/multiselect';

const defaultFilter = {
    app: APP_FEP,
    paymentStates: [],
    orderStates: [],
    idOrNumber: '',
    invoiceNumber: '',
    buyer: '',
}

export const Orders = () => {
    const match = useRouteMatch()
    const history = useHistory()

    const [dataList, setDataList] = useState([])
    const [filter, setFilter] = useState(defaultFilter)
    const [pageable, setPageable] = useState({        
        page: 0,
        rows: 10,
        total: 0,
        sortField: 'checkoutCompletedAt',
        sortOrder: -1
    })
    
    const [isLoadTable, setLoadTable] = useState(true);

    useEffect(()=>{
        if(isLoadTable)
            loadPageOrders()
    },[isLoadTable])

    const loadPageOrders = () => {
        getPageOrders(filter, pageable.page, pageable.rows, pageable.sortField, pageable.sortOrder)
        .then(res => {
            setDataList(res.content)
            setPageable({...pageable,
                total: res.totalElements,
                page: res.pageable.pageNumber,
                rows: res.pageable.pageSize
            })
            setLoadTable(false)
        })
    };

    const onPage = (e) =>{
        setPageable({...pageable,
            page: e.page
        })
        setLoadTable(true);
    }

    const onSort = (e) =>{
        setPageable({...pageable,
            sortField: e.sortField,
            sortOrder: e.sortOrder
        })
        setLoadTable(true);
    }

    const onChangePageLength = (e) => {
        setPageable({...pageable,
            rows: e,
            page: 0
        })
        setLoadTable(true);
    };

    const onFilterKeyPress = (e) => {
        if (e.key === 'Enter') {
            setLoadTable(true)
        }
    }

    const applyFilter = () => {
        setPageable({...pageable,
            page: 0
        })
        setLoadTable(true)
    }

    const resetFilter = () => {
        setPageable({...pageable,
            page: 0
        })
        setFilter(defaultFilter)
        setLoadTable(true)
    }

    const tblOrderHeader = (
        <TableHeader title="Orders" 
            pageReport={getTablePageReport(pageable.page, pageable.rows, pageable.total)}
            changePageLength={(e) => onChangePageLength(e)}
            refresh={() => setLoadTable(true)}
            />
    );

    return (
        <div className="p-grid">
            <BreadcrumbsItem to={match.url}>Orders</BreadcrumbsItem>

            <div className="p-col-12">
                <div className="card card-w-title">
                    <h1 className="p-w-bold">Orders</h1>

                    <Fieldset legend="Filters">
                        <div className="p-grid p-fluid form-group">
                            <div className="p-col-3 p-mr-6">
                                <div className="p-grid form-group">
                                    <div className="p-col-12">
                                        <div className="p-inputgroup">
                                            <span className="p-inputgroup-addon" style={{minWidth: '15%', textAlign: 'left'}}>ID/Code:</span>
                                            <InputText value={filter.idOrNumber} onKeyPress={onFilterKeyPress} onChange={(e) => setFilter({...filter, idOrNumber: e.target.value})} />
                                        </div>
                                    </div>
                                    <div className="p-col-12">
                                        <div className="p-inputgroup">
                                            <span className="p-inputgroup-addon" style={{minWidth: '45%', textAlign: 'left'}}>Invoice/Receipt Number:</span>
                                            <InputText keyfilter={/^[0-9]*$/} value={filter.invoiceNumber} onKeyPress={onFilterKeyPress} onChange={(e) => setFilter({...filter, invoiceNumber: e.target.value?parseInt(e.target.value):'' })} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="p-col-3 p-mr-6">
                                <div className="p-grid form-group">
                                    <div className="p-col-12">
                                        <div className="p-inputgroup">
                                            <span className="p-inputgroup-addon" style={{minWidth: '30%', textAlign: 'left'}}>Order State:</span>
                                            <MultiSelect value={filter.orderStates} options={Object.values(ORDER_STATE).filter(x => x.value!==ORDER_STATE.cart.value)} onChange={(e) => setFilter({...filter, orderStates: e.value})}
                                                style={{ minWidth: '12em' }} filter={true} placeholder="All" />
                                        </div>
                                    </div>
                                    <div className="p-col-12">
                                        <div className="p-inputgroup">
                                            <span className="p-inputgroup-addon" style={{minWidth: '30%', textAlign: 'left'}}>Payment State:</span>
                                            <MultiSelect value={filter.paymentStates} options={Object.values(PAYMENT_STATE)} onChange={(e) => setFilter({...filter, paymentStates: e.value})}
                                                style={{ minWidth: '12em' }} filter={true} placeholder="All" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="p-col-4 p-mr-6">
                                <div className="p-grid form-group">
                                    <div className="p-col-12">
                                        <div className="p-inputgroup">
                                            <span className="p-inputgroup-addon">Buyer:</span>
                                            <InputText value={filter.buyerName} onKeyPress={onFilterKeyPress} onChange={(e) => setFilter({...filter, buyer: e.target.value})} placeholder="Name/email/phone"/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="p-grid">
                            <div className="p-col-9" style={{ "textAlign": "center" }}>
                                <Button icon="pi pi-filter" iconPos="left" label="Search" onClick={() => applyFilter()} />
                                <Button className="p-button-warning" icon="pi pi-trash" iconPos="left" label="Clear" onClick={() => resetFilter()} />
                            </div>
                        </div>
                    </Fieldset>
                </div>

                <DataTable 
                    emptyMessage="There's no order" header={tblOrderHeader} 
                    value={dataList} lazy={true} loading={isLoadTable}
                    paginator={true} first={pageable.page * pageable.rows} rows={pageable.rows} totalRecords={pageable.total}
                    sortField={pageable.sortField} sortOrder={pageable.sortOrder}
                    onPage={onPage} onSort={onSort}
                    responsive={true}
                >
                    <Column header="ID-Code" field="id" bodyClassName="p-c" style={{width:'10em'}} sortable={true}
                        body={rowData => <Button label={rowData.id + " - " + rowData.orderNumber} icon="pi pi-search" className="p-button-info" tooltip='View order' tooltipOptions={{position: "top"}} onClick={() => history.push(`/orders/${rowData.id}`)}/>}/>
                    <Column header="Buyer" field="billEmail" sortable={true} bodyClassName="p-nowrap" style={{width: '18em'}}
                        body={(rowData) => <React.Fragment><div>{rowData.billName + ' - [' + rowData.billEmail + ']'}</div>{rowData.billPhone && <div>{rowData.billPhone}</div>}</React.Fragment> }/>
                    {/* <Column header="Buyer" field="billEmail" sortable={true} bodyClassName="p-nowrap" style={{width: '18em'}}
                        body={(rowData) => {
                            return (
                                <Tippy
                                    content={<ContactDetailsCard data={rowData}/>}
                                    animation="fade"
                                    placement="right"
                                    trigger="mouseenter focus"
                                    interactive={true}
                                    arrow={true}
                                    theme="light"
                                    maxWidth= 'none'
                                    duration={[350, 200]}>
                                    <button className="Tippy-Button">
                                    {rowData.customerName + ' - [' + rowData.customerEmail + ']'}
                                    </button>
                                </Tippy>
                            );
                            }} /> */}
                    <Column header="Total" field="total" body={(rowData) => moneyFormat(rowData.total, rowData.currency)} bodyClassName="p-r p-w-bold" sortable={true} style={{width: '7em'}} />
                    <Column header="Security  Deposit" field="pledgedDepositTotal" body={(rowData) => rowData.pledgedDepositTotal>0?moneyFormat(rowData.pledgedDepositTotal, rowData.currency):''} bodyClassName="p-r p-w-bold" sortable={true} style={{width: '8em'}} />
                    <Column header="Paid" field="paidTotal" body={(rowData) => moneyFormat(rowData.paidTotal, rowData.currency)} bodyClassName="p-r p-w-bold" sortable={true} style={{width: '7em'}} />
                    <Column header="Payment State" field="paymentState" body={(rowData) => <span className={classNames('status', rowData.paymentState)}>{PAYMENT_STATE[rowData.paymentState].label}</span>} bodyClassName="p-c" sortable={true} style={{width: '8em'}} />
                    <Column header="Order State" field="orderState" body={(rowData) => <span className={classNames('status', rowData.orderState)}>{ORDER_STATE[rowData.orderState].label}</span>} bodyClassName="p-c" sortable={true} style={{ textAlign: 'center', width: '6em'}} />
                    <Column header="Created At" field="checkoutCompletedAt" headerStyle={{width: '10em'}} bodyClassName="p-nowrap p-c" sortable={true} 
                        body={rowData => rowData.checkoutCompletedAt && moment(rowData.checkoutCompletedAt).format('MM/DD/YYYY hh:mm A')}
                    />
                </DataTable>
            </div>
        </div>
    )
}